import { update } from "../../utils";

export default {
  namespaced: true,
  state: {
    thirdPartyData: [],
  },
  actions: {},
  mutations: {
    update,
  },
};
